import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BookCard = ({ book }) => {
  const [isHovered, setIsHovered] = useState(false);
  const getThemeTextColor = (theme) => {
    switch (theme) {
      case 'Agenda':
        return 'text-blue-700';
      case 'Autoayuda':
        return 'text-purple-700';
      case 'Amor':
        return 'text-amber-700';
      case 'Astrología':
        return 'text-cyan-700';
      default:
        return 'text-gray-700';
    }
  };

  return (
      <Link
          to={`/books/${book?.id}`}
          className="block"
      >
        <div
            className={`group relative bg-card border literary-border rounded-lg literary-shadow literary-transition hover:literary-shadow-elevated h-full flex flex-col`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
          {/* Book Cover */}
          <div className="relative overflow-hidden rounded-t-lg">
            <Image
                src={book?.image}
                alt={`Portada de ${book?.title}`}
                className="w-full h-56 sm:h-64 object-cover"
            />

            {/* Overlay on Hover */}
            <div className={`absolute inset-0 bg-black/40 flex items-center justify-center literary-transition ${
                isHovered ? 'opacity-100' : 'opacity-0'
            }`}>
              <div className="flex space-x-2">
              </div>
            </div>

            {/* New Badge */}
            {book?.isNew && (
                <div className="absolute bottom-3 left-3 px-2 py-1 bg-accent text-accent-foreground text-xs font-cta font-medium rounded-md">
                  Nuevo
                </div>
            )}
          </div>
          {/* Book Details */}
          <div className="p-2">
            {/* Title and Author */}
            <div className="mb-1">
              <h3 className="font-headline text-base sm:text-lg font-semibold line-clamp-2">
              {book?.title}
              </h3>
              <p className="font-body text-sm text-scholarly-gray">
                {book?.year}
              </p>
            </div>

            {/* Themes */}
            <div className="flex flex-wrap gap-1 sm:gap-2">
              {book?.themes?.slice(0, 2)?.map((theme, index) => (
                  <span
                      key={index}
                      className={`
        px-1 py-0.5 text-[10px]
        sm:px-2 sm:py-1 sm:text-xs
        font-cta font-medium rounded-full
        ${getThemeTextColor(theme)} bg-white/60
      `}
                  >
      {theme}
    </span>
              ))}

              {book?.themes?.length > 2 && (
                  <span
                      className="
        px-1 py-0.5 text-[10px]
        sm:px-2 sm:py-1 sm:text-xs
        font-cta font-medium rounded-full
        text-gray-600 bg-white/60
      "
                  >
      +{book?.themes?.length - 2}
    </span>
              )}
            </div>

          </div>
        </div>
      </Link>
  );
};

export default BookCard;